import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

/*
  Generated class for the Favoriteprovider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class Favoriteprovider {

  constructor(public storage: Storage) {
    console.log('Hello Favoriteprovider Provider');
  }
    
  getFavorites() {
    return this.storage.get('favorites');  
  }
 
  save(data){
    let newData = JSON.stringify(data);
    this.storage.set('favorites', newData);
  }

}



// WEBPACK FOOTER //
// ./src/providers/favoriteprovider.ts